import React, { Component } from "react";
import FieldError from "./FieldError";
import {cx} from "../../lib/ClassSet";
import ReactTelephoneInput from "react-telephone-input";
import "./TelephoneInputField.css";

const noOp = () => null;

class TelephoneInputField extends Component {

  constructor(props) {
    super(props);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = {
      focused: false
    }
  }

  render() {
    const {serverError, label, active, input: {value, onChange}, meta: {touched, error}} = this.props;    

    let changeHandler = active ? onChange : noOp;
    let classes = cx({
      "TelephoneInput": true,
      "s-inactive": !active,
      "s-focused": this.state.focused
    });

    return (
      <tr className="TelephoneInputField field">
        <th>{label}</th>
        <td>
          <ReactTelephoneInput
            value={value}
            className={classes}
            defaultCountry="us"
            preferredCountries={["us"]}
            disable={!this.props.active}
            flagsImagePath="/images/flags.png"
            onChange={changeHandler}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            />
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )      
  }

  handleFocus(e) {
    this.setState({focused: true});
  }

  handleBlur(e) {
    this.setState({focused: false});
  }

}

TelephoneInputField.defaultProps = {
  active: true,
  mode: "table"
}

export default TelephoneInputField;